import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import { useData } from "../../context/DataProvider";
import styles from "./ThemesPage.module.scss";

export interface IThemesPageItem {
  baslik: string;
  aciklama: string;
  yatayGorsel: string | null;
  kapakGorsel: string | null;
  detayGorsel: string | null;
  sira: number;
  projeler: any[];
  id: string;
  status: number;
  createdDate: string;
  updatedDate: string | null;
}

const rowPatterns =
  window.innerWidth <= 768
    ? [
        [50, 50],
        [50, 50],
        [50, 50],
      ]
    : [
        [25, 25, 25, 25],
        [25, 25, 25, 25],
        [25, 25, 25, 25],
      ];

const ThemesPage: React.FC = () => {
  const navigate = useNavigate();
  const { tema: items, isLoading, error } = useData();

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  // Gizli temayı bul
  const firstImage = items.find(
    (item) => item.baslik === "gizli" && item.aciklama === "gizli"
  );

  // Grid için diğer temaları hazırla
  const gridItems = items.filter(
    (item) => !(item.baslik === "gizli" && item.aciklama === "gizli")
  );

  //sıraya göre sırala
  const sortedItems = [...gridItems].sort((a, b) => {
    return a.sira - b.sira;
  });

  const allRows = [];
  let currentIndex = 0;
  let patternIndex = 0;

  const displayList: IThemesPageItem[] = [];

  sortedItems.forEach((itm) => {
    displayList.push({
      ...itm,
      kapakGorsel: itm.kapakGorsel,
      detayGorsel: null,
    });
    displayList.push({
      ...itm,
      kapakGorsel: null,
      detayGorsel: itm.detayGorsel,
    });
  });

  while (currentIndex < displayList.length) {
    const widths = rowPatterns[patternIndex];
    const itemCount = widths.length;
    const rowItems = displayList.slice(currentIndex, currentIndex + itemCount);

    allRows.push({ widths, items: rowItems });

    currentIndex += itemCount;
    patternIndex = (patternIndex + 1) % rowPatterns.length;
  }

  return (
    <div className={styles.container}>
      {/* Gizli tema için büyük görsel */}
      {firstImage && (
        <div className={styles.firstRow}>
          <div className={styles.firstImage}>
            <img src={firstImage.detayGorsel || ""} alt={firstImage.baslik} />
          </div>
        </div>
      )}

      {/* Grid yapısı */}
      <div className={styles.gridContainer}>
        {allRows.map((row, rowIndex) => (
          <div key={rowIndex} className={styles.row}>
            {row.items.map((item, itemIndex) => {
              const width = row.widths[itemIndex];

              return (
                <div
                  key={item.id}
                  className={styles.item}
                  style={{ width: `${width}%` }}
                  onClick={() => {
                    if (item.kapakGorsel) {
                      navigate(`/temaDetay/${item.baslik}`);
                    }
                  }}
                >
                  <img
                    src={
                      item.kapakGorsel
                        ? item.kapakGorsel
                        : item.detayGorsel || ""
                    }
                    style={{
                      cursor: item.kapakGorsel ? "pointer" : "default",
                    }}
                    alt={item.baslik}
                    className={styles.image}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemesPage;
